export const getUserProfileForAdminProject = (usersObj, senderId) => {
    const {user, member1, member2} = usersObj
    if(senderId === user._id){
        return user
    } else if(senderId === member1._id){
        return member1
    } else {
        return member2
    }
}